<template>
  <div>
    <article class="slds-card slds-card_boundary">
      <div class="slds-card__body slds-card__body_inner">
        <FullCalendar
          default-view="dayGridMonth"
          @eventClick="goToEvent"
          :events="localCampaigns"
          :height="0"
          :locale="calendarLocale"
          :plugins="calendarPlugins" />
      </div>
    </article>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'

export default {
  props: {
    campaigns: Array
  },
  components: {
    FullCalendar
  },
  async created () {
    this.calendarLocale = this.$store.getters['session/locale']
    this.localCampaigns = this.mapCampaigns(this.campaigns)
    this.$store.watch((state, getters) => getters['session/locale'],
      newValue => {
        this.calendarLocale = newValue
      }
    )
  },
  data () {
    return {
      calendarPlugins: [dayGridPlugin],
      localCampaigns: [],
      calendarLocale: ''
    }
  },
  methods: {
    goToEvent (event) {
      this.$router.push(`/campaigns/${event.event.id}`)
    },
    mapCampaigns (campaigns) {
      const campaignTypes = this.$store.getters['settings/settings'].campaignTypes
      //const settingTemp = this.$store.getters['settings/settings']
      return campaigns.map(campaign => {
        let backgroundColor
        try {
          backgroundColor = campaignTypes.find(type => type.name === campaign.type).color
        } catch (error) {
          console.error(`Error with campaign ${campaign.type}`)
          backgroundColor = '#000000'
        }
        let textColor

        switch (backgroundColor) {
          case '#00AE5A':
          case '#8BC5F5':
          case '#FFBD39':
            textColor = '#FFFFFF'
            break
          case '#FFFB4C':
            textColor = '#000000'
        }

        return {
          allDay: true,
          backgroundColor,
          textColor,
          id: campaign.id,
          date: campaign.startDate,
          title: campaign.name
        }
      })
    }
  },
  mounted () {
    this.$emit('rendered')
  },
  watch: {
    campaigns (campaigns) {
      this.localCampaigns = this.mapCampaigns(campaigns)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';

  .fc-view table {
    height: 800px;
  }
</style>
